import React, { Children } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeftIcon, FilterIcon, MapPinIcon, BookOpenIcon, Mountain, Calendar } from 'lucide-react';
import CommunityCard from '../components/CommunityCard';
const CategoryDetail = () => {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  // Mock data mapping category IDs to names
  const categoryNames: Record<string, string> = {
    sports: 'Sports & Fitness',
    arts: 'Arts & Culture',
    prof: 'Professional',
    hobbies: 'Hobbies',
    volunteer: 'Volunteering',
    education: 'Education'
  };
  // Mock communities data
  const communities = [{
    id: '101',
    name: 'WeRun Nairobi',
    description: 'A community of runners in Nairobi meeting every weekend for group runs and training.',
    memberCount: 358,
    location: 'Nairobi',
    category: 'Sports & Fitness',
    nextEvent: 'Saturday Run, 6AM',
    websiteUrl: 'https://werunnairobi.co.ke'
  }, {
    id: '102',
    name: 'Nairobi Road Cycling',
    description: 'Group cycling for road bike enthusiasts in and around Nairobi.',
    memberCount: 213,
    location: 'Nairobi',
    category: 'Sports & Fitness',
    nextEvent: 'Sunday Ride, 5:30AM',
    websiteUrl: 'https://nairobicycling.co.ke'
  },
  // Hiking events for September 2025
  {
    id: '103',
    name: 'Ngong Hills Hike',
    description: 'Join us for a scenic hike through Ngong Hills with two route options available: short and long. Perfect for both beginners and experienced hikers.',
    memberCount: 125,
    location: 'Ngong Hills',
    category: 'Sports & Fitness',
    nextEvent: 'September 6, 2025 - 7:00 AM',
    websiteUrl: '#',
    isEvent: true,
    difficulty: 'Easy',
    contact: 'Contact JoinToday for favorable rates and discounts!'
  }, {
    id: '104',
    name: 'Kanze Gorges Hike',
    description: 'Explore the beautiful Kanze Gorges on this moderate difficulty hike. Experience breathtaking views and challenging terrain.',
    memberCount: 95,
    location: 'Kanze Gorges',
    category: 'Sports & Fitness',
    nextEvent: 'September 13, 2025 - 6:30 AM',
    websiteUrl: '#',
    isEvent: true,
    difficulty: 'Moderate',
    contact: 'Contact JoinToday for favorable rates and discounts!'
  }, {
    id: '105',
    name: 'Namanga Hills Hike (Sunday Edition)',
    description: 'A special Sunday edition hike to Namanga Hills. This moderate hike offers beautiful landscapes and is perfect for weekend adventurers.',
    memberCount: 87,
    location: 'Namanga',
    category: 'Sports & Fitness',
    nextEvent: 'September 14, 2025 - 7:00 AM',
    websiteUrl: '#',
    isEvent: true,
    difficulty: 'Moderate',
    contact: 'Contact JoinToday for favorable rates and discounts!'
  }, {
    id: '106',
    name: 'Mt. Longonot Hike',
    description: "Hike one of Kenya's most popular trails - Mt. Longonot. This classic trail offers stunning views of the Great Rift Valley and the crater.",
    memberCount: 142,
    location: 'Mt. Longonot',
    category: 'Sports & Fitness',
    nextEvent: 'September 20, 2025 - 6:00 AM',
    websiteUrl: '#',
    isEvent: true,
    difficulty: 'Moderate',
    contact: 'Contact JoinToday for favorable rates and discounts!'
  }, {
    id: '201',
    name: 'Kenya Business Network',
    description: 'Professional networking group for business leaders and entrepreneurs in Kenya.',
    memberCount: 526,
    location: 'Multiple Locations',
    category: 'Professional',
    nextEvent: 'Monthly Meetup, Wed 6PM',
    websiteUrl: 'https://kbn.co.ke'
  }, {
    id: '301',
    name: 'Nairobi Art Collective',
    description: 'Community of visual artists, sculptors, and art enthusiasts in Nairobi.',
    memberCount: 187,
    location: 'Nairobi',
    category: 'Arts & Culture',
    nextEvent: 'Gallery Opening, Fri 7PM',
    websiteUrl: 'https://nairobiart.org'
  },
  // Book Clubs for Adults and General Audiences
  {
    id: '401',
    name: 'Soma Nami Book Club',
    description: 'A monthly book club in Nairobi that focuses on showcasing the diversity of African literature.',
    memberCount: 145,
    location: 'Nairobi',
    category: 'Education',
    nextEvent: 'Book Discussion, Sep 15, 2025',
    websiteUrl: 'https://somanami.co.ke'
  }, {
    id: '402',
    name: 'Matigari Book Club',
    description: "An educational program at the Mathare Social Justice Centre, named after Ngugi Wa Thiongo's book, focused on youth and social justice issues.",
    memberCount: 78,
    location: 'Mathare, Nairobi',
    category: 'Education',
    nextEvent: 'Social Justice Workshop, Oct 5, 2025',
    websiteUrl: 'https://matharesocialjustice.org'
  }, {
    id: '403',
    name: 'Nairobi Book Club',
    description: 'A large online community that connects readers countrywide for discussions and recommendations.',
    memberCount: 1250,
    location: 'Online/Nairobi',
    category: 'Education',
    nextEvent: 'Virtual Book Discussion, Aug 25, 2025',
    websiteUrl: 'https://facebook.com/nairobibookclub'
  }, {
    id: '404',
    name: 'Silent Book Club - Kenya',
    description: 'A group for book lovers to connect, socialize, and share recommendations while enjoying dedicated quiet reading time.',
    memberCount: 210,
    location: 'Various Locations',
    category: 'Education',
    nextEvent: 'Silent Reading Session, Sep 10, 2025',
    websiteUrl: 'https://facebook.com/silentbookclubkenya'
  }, {
    id: '405',
    name: "Wambui's Book Club",
    description: 'A book club that promotes African literature and hosts events, often in partnership with venues like Artcaffe Market.',
    memberCount: 95,
    location: 'Nairobi',
    category: 'Education',
    nextEvent: 'Author Meet & Greet, Oct 12, 2025',
    websiteUrl: 'https://wambuisbookclub.co.ke'
  },
  // Book Clubs for Children and Youth
  {
    id: '406',
    name: 'Africa Kids Book Club',
    description: "An organization offering monthly kids' book clubs, virtual options, and a focus on building reading and writing skills, STEM exploration, and creativity.",
    memberCount: 180,
    location: 'Multiple Locations',
    category: 'Education',
    nextEvent: "Children's Reading Session, Sep 8, 2025",
    websiteUrl: 'https://africakidsbookclub.org'
  }, {
    id: '407',
    name: 'Storymoja Book Club',
    description: 'An initiative by Storymoja Publishers to set up book clubs in high schools, promoting social justice through youth literature.',
    memberCount: 320,
    location: 'School Partnerships',
    category: 'Education',
    nextEvent: 'High School Reading Challenge, Oct 20, 2025',
    websiteUrl: 'https://storymojaafrica.co.ke'
  }, {
    id: '408',
    name: "The Youth Cafe's Library Program",
    description: 'A program in Nairobi that provides access to books for youth, including borrowing services, mobile library outreach, and services to prisons and hospitals.',
    memberCount: 275,
    location: 'Nairobi & Outreach',
    category: 'Education',
    nextEvent: 'Mobile Library Visit, Sep 18, 2025',
    websiteUrl: 'https://theyouthcafe.com/library'
  }];
  // Filter communities based on the category
  const filteredCommunities = communities.filter(community => community.category === categoryNames[id || '']);
  // Group communities by type if education category is selected
  const isEducationCategory = categoryNames[id || ''] === 'Education';
  const adultBookClubs = isEducationCategory ? filteredCommunities.filter(c => ['401', '402', '403', '404', '405'].includes(c.id)) : [];
  const childrenBookClubs = isEducationCategory ? filteredCommunities.filter(c => ['406', '407', '408'].includes(c.id)) : [];
  const otherEducationalCommunities = isEducationCategory ? filteredCommunities.filter(c => !['401', '402', '403', '404', '405', '406', '407', '408'].includes(c.id)) : [];
  // Group communities by type if sports category is selected
  const isSportsCategory = categoryNames[id || ''] === 'Sports & Fitness';
  const hikingEvents = isSportsCategory ? filteredCommunities.filter(c => ['103', '104', '105', '106'].includes(c.id)) : [];
  const otherSportsCommunities = isSportsCategory ? filteredCommunities.filter(c => !['103', '104', '105', '106'].includes(c.id)) : [];
  return <div className="p-4" data-id="element-888">
      <Link to="/categories" className="inline-block mb-4" data-id="element-889">
        <ArrowLeftIcon className="w-5 h-5 text-gray-700 dark:text-gray-300" data-id="element-890" />
      </Link>
      <h1 className="text-2xl font-bold mb-2 dark:text-gray-200" data-id="element-891">
        {categoryNames[id || ''] || 'Category'}
      </h1>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-4" data-id="element-892">
        Discover communities and events related to{' '}
        {categoryNames[id || ''] || 'this category'} across Kenya.
      </p>
      <div className="flex justify-between items-center mb-4" data-id="element-893">
        <div className="text-sm dark:text-gray-300" data-id="element-894">
          {filteredCommunities.length} communities found
        </div>
        <button className="flex items-center text-sm border border-gray-300 dark:border-gray-600 rounded-md px-3 py-1 dark:text-gray-200 transition-all duration-300 hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-895">
          <FilterIcon className="w-4 h-4 mr-1" data-id="element-896" />
          Filter
        </button>
      </div>
      <div className="mb-4" data-id="element-897">
        <div className="flex overflow-x-auto pb-2 gap-2" data-id="element-898">
          <button className="whitespace-nowrap px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-full text-sm bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 transition-all duration-300 hover:bg-gray-700 dark:hover:bg-gray-300" data-id="element-899">
            All Locations
          </button>
          <button className="whitespace-nowrap px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-full text-sm dark:text-gray-200 transition-all duration-300 hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-900">
            Nairobi
          </button>
          <button className="whitespace-nowrap px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-full text-sm dark:text-gray-200 transition-all duration-300 hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-901">
            Mombasa
          </button>
          <button className="whitespace-nowrap px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-full text-sm dark:text-gray-200 transition-all duration-300 hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-902">
            Kisumu
          </button>
          <button className="whitespace-nowrap px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-full text-sm dark:text-gray-200 transition-all duration-300 hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-903">
            Online
          </button>
        </div>
      </div>
      {isEducationCategory ? <div className="space-y-6" data-id="element-904">
          {adultBookClubs.length > 0 && <div data-id="element-905">
              <div className="flex items-center mb-3" data-id="element-906">
                <BookOpenIcon className="w-5 h-5 mr-2 dark:text-gray-300" data-id="element-907" />
                <h2 className="text-lg font-bold dark:text-gray-200" data-id="element-908">
                  Book Clubs for Adults & General Audiences
                </h2>
              </div>
              <div className="space-y-4" data-id="element-909">
                {adultBookClubs.map(community => <CommunityCard key={community.id} {...community} data-id="element-910" />)}
              </div>
            </div>}
          {childrenBookClubs.length > 0 && <div data-id="element-911">
              <div className="flex items-center mb-3" data-id="element-912">
                <BookOpenIcon className="w-5 h-5 mr-2 dark:text-gray-300" data-id="element-913" />
                <h2 className="text-lg font-bold dark:text-gray-200" data-id="element-914">
                  Book Clubs for Children & Youth
                </h2>
              </div>
              <div className="space-y-4" data-id="element-915">
                {childrenBookClubs.map(community => <CommunityCard key={community.id} {...community} data-id="element-916" />)}
              </div>
            </div>}
          {otherEducationalCommunities.length > 0 && <div data-id="element-917">
              <div className="flex items-center mb-3" data-id="element-918">
                <MapPinIcon className="w-5 h-5 mr-2 dark:text-gray-300" data-id="element-919" />
                <h2 className="text-lg font-bold dark:text-gray-200" data-id="element-920">
                  Other Educational Communities
                </h2>
              </div>
              <div className="space-y-4" data-id="element-921">
                {otherEducationalCommunities.map(community => <CommunityCard key={community.id} {...community} data-id="element-922" />)}
              </div>
            </div>}
        </div> : isSportsCategory ? <div className="space-y-6" data-id="element-923">
          {hikingEvents.length > 0 && <div data-id="element-924">
              <div className="flex items-center mb-3" data-id="element-925">
                <Mountain className="w-5 h-5 mr-2 dark:text-gray-300" data-id="element-926" />
                <h2 className="text-lg font-bold dark:text-gray-200" data-id="element-927">
                  Upcoming Hiking Events
                </h2>
              </div>
              <div className="space-y-4" data-id="element-928">
                {hikingEvents.map(community => <div key={community.id} className="border border-gray-300 dark:border-gray-600 rounded-lg p-4 transition-all duration-300 hover:border-gray-400 dark:hover:border-gray-500" data-id="element-929">
                    <div className="flex justify-between items-start" data-id="element-930">
                      <div data-id="element-931">
                        <h3 className="font-bold dark:text-gray-200" data-id="element-932">
                          {community.name}
                        </h3>
                        <div className="flex items-center mt-1 text-sm text-gray-600 dark:text-gray-400" data-id="element-933">
                          <Calendar className="w-4 h-4 mr-1" data-id="element-934" />
                          <span data-id="element-935">{community.nextEvent}</span>
                        </div>
                        <div className="flex items-center mt-1 text-sm text-gray-600 dark:text-gray-400" data-id="element-936">
                          <MapPinIcon className="w-4 h-4 mr-1" data-id="element-937" />
                          <span data-id="element-938">{community.location}</span>
                        </div>
                      </div>
                      <div className="bg-gray-200 dark:bg-gray-700 px-2 py-1 rounded text-xs" data-id="element-939">
                        {community.difficulty}
                      </div>
                    </div>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-3" data-id="element-940">
                      {community.description}
                    </p>
                    <div className="mt-3 text-sm text-gray-600 dark:text-gray-400 italic" data-id="element-941">
                      {community.contact}
                    </div>
                    <div className="mt-3 flex justify-end" data-id="element-942">
                      <button className="px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-md text-sm dark:text-gray-200 transition-all duration-300 hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-943">
                        Register Interest
                      </button>
                    </div>
                  </div>)}
              </div>
            </div>}
          {otherSportsCommunities.length > 0 && <div data-id="element-944">
              <div className="flex items-center mb-3" data-id="element-945">
                <MapPinIcon className="w-5 h-5 mr-2 dark:text-gray-300" data-id="element-946" />
                <h2 className="text-lg font-bold dark:text-gray-200" data-id="element-947">
                  Sports & Fitness Communities
                </h2>
              </div>
              <div className="space-y-4" data-id="element-948">
                {otherSportsCommunities.map(community => <CommunityCard key={community.id} {...community} data-id="element-949" />)}
              </div>
            </div>}
        </div> : <div className="space-y-4" data-id="element-950">
          {filteredCommunities.length > 0 ? filteredCommunities.map(community => <CommunityCard key={community.id} {...community} data-id="element-951" />) : <div className="text-center py-10 border border-gray-300 dark:border-gray-600 rounded-lg transition-all duration-300 hover:border-gray-400 dark:hover:border-gray-500" data-id="element-952">
              <MapPinIcon className="w-10 h-10 mx-auto text-gray-400 dark:text-gray-500 mb-2" data-id="element-953" />
              <p className="text-gray-500 dark:text-gray-400" data-id="element-954">
                No communities found in this category.
              </p>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-1" data-id="element-955">
                Try changing your filters or check back later.
              </p>
            </div>}
        </div>}
    </div>;
};
export default CategoryDetail;